export default "__VITE_ASSET__c13fd53c__"